<template>
  <div class="news-detail">
    <div class="container">
      <div class="detail-container">
        <div class="breadcrumb">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">{{$t("newsDetail.home")}}</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/news' }">{{$t("newsDetail.lists")}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <section class="head">
          <h1>{{detailInfo.title}}</h1>
          <div class="share-row">
            <div>
              <span class="mr20">{{$t("newsDetail.time")}}{{detailInfo.createTime}}</span><span>{{$t("newsDetail.edit")}}</span>
            </div>
            <div class="hidden-xs-only">
              <span class="mr20">{{$t("newsDetail.share")}}</span>

                <!-- <el-popover placement="bottom" width="400" trigger="hover">
                  <div class="popover-pic" ref='imageDom' >
                    
                    <h3>{{detailInfo.title}}</h3>
                    <div class="introduction" v-html="detailInfo.content"> </div>
                    <div class="code">
                      <img src="../../assets/img/base/logo.png" class="logo"/>
                      <img src="../../assets/img/base/gzh.png" class="gzh"/>
                    </div>
                  </div>
                
                  <div class="save-btn">
                    <el-button block @click="setCanvas(detailInfo.title)" size="mini">保存图片</el-button>
                  </div>
                    
                 <el-button slot="reference" circle><img src="../../assets/img/businessScope/bulkTrade/pic_icon.png" alt=""/></el-button>
                </el-popover> -->

                <el-popover
                  placement="bottom"
                  trigger="hover"
                  :content="$t('bulkTradeDetail.copyAddress')"
                  width="150"
                  class="ml20">
                  <el-button slot="reference" circle @click="copeLike"><img src="../../assets/img/businessScope/bulkTrade/link_icon.png" alt=""/></el-button>
                </el-popover>
            </div>
          </div>
        </section>
        <!-- <div class="introduction" v-html="detailInfo.content"> </div> -->
        <editor v-model="detailInfo.content" :readOnly="true"/>
        <div class="page">
          <p v-if="detailInfo.contentPre" @click="toDetail(detailInfo.contentPre.id)">{{$t("newsDetail.pre")}}{{detailInfo.contentPre.title}}</p>
          <p v-if="detailInfo.contentAfter" @click="toDetail(detailInfo.contentAfter.id)">{{$t("newsDetail.next")}}{{detailInfo.contentAfter.title}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getnewdetail } from "../../api/news"
import html2canvas from "html2canvas"
export default {
  name: "NewsDetail",
  data() {
    return {
      detailInfo: {}, 
    }
  },
  computed:{
    ...mapGetters(['language']),
    id(){
      return this.$route.params.id
    }
  },
  mounted() {
    var options = { live: false };
    new this.$wow.WOW(options).init();
    console.log(document.location.href)
    getnewdetail(this.language,this.id).then(res=>{
      this.detailInfo = res.data
    });
  },
  methods: {
    toDetail(id) {
      this.$router.push({ path: `/news/detail/${id}` });
      this.$router.go(0);
    },
    copeLike(){
      this.$copyText(document.location.href).then( (e)=> {
          this.$message.success('复制成功');
        }, function (e) {
          this.$message.error('复制失败');
      })
    },
    setCanvas (name) {
      const canvas = document.createElement('canvas')
      // 获取要生成图片的 DOM 元素
      let canvasDom = this.$refs.imageDom
      // 获取指定的宽高
      const width = parseInt(window.getComputedStyle(canvasDom).width)
      const height = parseInt(window.getComputedStyle(canvasDom).height)
      // 宽高扩大 2 倍 处理图片模糊
      canvas.width = width 
      canvas.height = height 
      canvas.style.width = width  + 'px'
      canvas.style.height = height  + 'px'

      const context = canvas.getContext('2d')
      context.scale(1, 1)
      const options = {
        backgroundColor: null,
        canvas: canvas,
        useCORS: true
      }

      html2canvas(canvasDom,options).then(canvas => {
        // console.log(canvas)
        // 兼容ie
        if(window.navigator.msSaveBlob){
          var blob = canvas.msToBlob()
          window.navigator.msSaveBlob(blob, name+'.png')
        } else {
          var url = canvas.toDataURL('image/png')     //把canvas转成base64
          // <a id="tttt" href="" style="display:none"></a>  这是html，随便放页面的哪里都行
          // 写一个隐藏的按标签，借助按标签的download属性下载图片
          let aLink = document.createElement("a");
          aLink.style.display = "none";
          aLink.href = url;
          aLink.download = name+".png";
          aLink.click()
        }
      })
  
    }
  },
};
</script>

<style scoped lang="scss">
$cblue: #0054a7;
.news-detail{
  .detail-container{
    width:70%;
    margin:0 auto;
  }
  .breadcrumb{
    margin:50px 0;
  }
  .head{
    margin-bottom:40px;
    padding-bottom:20px;
    border-bottom:1px solid #E3E3E3;
    h1{
      font-size: 32px;
      color:$cblue;
      margin-bottom:20px;
    }
    .share-row{
      display: flex;
      justify-content: space-between;
      align-items: center;
      color:#999;
    }
  }
  .introduction{
    border-bottom:1px solid #E3E3E3;
    padding-bottom:40px;
    text-align: justify;
  }
  .page{
    padding-top:30px;
    margin-bottom:30px;
    p+p{
      margin-top:10px;
    }
    p:hover{
      color:$cblue;
      cursor: pointer;
    }
  }
  @media screen and (max-width:768px){
    .detail-container{
      width:100%;
      margin:0 auto;
    }
    .breadcrumb{
      margin:40px 0;
    }
    .head{
      margin-bottom:40px;
      padding-bottom:20px;
      border-bottom:1px solid #E3E3E3;
      h1{
        font-size: 20px;
        color:$cblue;
        margin-bottom:20px;
      }
      .share-row{
        display: inherit;
        justify-content: space-between;
        align-items: center;
        color:#999;
      }
    }
    .introduction{
      border-bottom:1px solid #E3E3E3;
      padding-bottom:40px;
      text-align: justify;
    }
    
  }
}

.el-popover.el-popper{
  .popover-pic{
    box-sizing: border-box;
    background:#fff;
    padding:20px;
    h3{
      font-weight: bold;
    }
    .code{
      padding-top:20px;
      margin-top:20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top:1px solid #999;
      .logo{
        width:200px;
      }
      .gzh{
        width:100px;
      }
    }
  }
  .save-btn{
      position:absolute;
      right:0;
      bottom:0;
  }
}

</style>
<style>
.ql-toolbar.ql-snow{
    display: none;
  }
  .ql-container.ql-snow{
    border:none;
    border-bottom:1px solid #E3E3E3;
    padding-bottom:40px;
  }
</style>
